<div class="user-record">

  <h1>{{ userType === adminUserTypes.Households ? 'Household' : userType }} Record</h1>
  @if (userType === adminUserTypes.Households) {
    <div class="academic-year-filter">
            <label for="rostersAcademicYearId">Academic Year</label>
            <mat-form-field>
              <mat-select
                id="rostersAcademicYearId"
                [value]="academicYearId"
                [disabled]="isLoadingAcademicYears || academicYears.length === 0"
                (selectionChange)="onAcademicYearChange($event.value)">
                @if (isLoadingAcademicYears) {
                  <mat-option disabled>Loading academic years...</mat-option>
                } @else if (academicYears.length === 0) {
                  <mat-option disabled>No academic years available</mat-option>
                } @else {
                  @for (year of academicYears; track year.id) {
                    <mat-option [value]="year.id">{{ year.name }}</mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
  </div>
  }
  <div class="user-record-container">
    @if (userData()?.isValidEmail === false) {
      <span class="recipient-scheduling-note"
        >Note: Invalid email address. Recipient will not appear in recipients list when scheduling a
        communication.</span
      >
    }
    @if (showSchoolLoadingSpinner) {
      <div class="school-record-loading-overlay">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    }
    <div class="user-record-grid grid">
      <!-- Basic Information -->
      <div class="user-info-container grid-col-12 grid-md:col-12">
        <lib-user-info-panel
          [enableEdit]="true"
          [isLoading]="userLoading"
          [schoolStatus]="schoolStatus()"
          [schoolRestrictionMessage]="schoolRestrictionMessage()"
          [userData]="userData()"
          [userType]="userType"
          [canEdit]="canEdit"
          (edit)="onEdit()">
        </lib-user-info-panel>
      </div>

      <!-- Other Contacts -->
      @if (userType === adminUserTypes.Schools) {
        <ng-container *ngTemplateOutlet="issueTracking"></ng-container>
        <ng-container *ngTemplateOutlet="otherContacts"></ng-container>
      }

      <!-- Students -->
      @if (userType === adminUserTypes.Households) {
        <ng-container *ngTemplateOutlet="students"></ng-container>
        <ng-container *ngTemplateOutlet="messages"></ng-container>
        <ng-container *ngTemplateOutlet="tasks"></ng-container>
        @if (showIncomeVerification) {
          <ng-container *ngTemplateOutlet="incomeVerification"></ng-container>
        }
        <ng-container *ngTemplateOutlet="internalComments"></ng-container>
        <ng-container *ngTemplateOutlet="documents"></ng-container>
        <ng-container *ngTemplateOutlet="emails"></ng-container>
      }

      @if (userType !== adminUserTypes.Households) {
        <ng-container *ngTemplateOutlet="tasks"></ng-container>
        <ng-container *ngTemplateOutlet="internalComments"></ng-container>
        <ng-container *ngTemplateOutlet="messages"></ng-container>
        <ng-container *ngTemplateOutlet="documents"></ng-container>
      }

      <!-- Payment Information -->
      @if (userType === adminUserTypes.Schools) {
        <ng-container *ngTemplateOutlet="paymentInformation"></ng-container>
      }

      <!-- Employees -->
      @if (userType === adminUserTypes.Provider) {
        <ng-container *ngTemplateOutlet="employees"></ng-container>
      }

      <!-- Other Contacts -->
      <ng-template #otherContacts>
        @if (userType === adminUserTypes.Schools) {
          <div class="grid-col-12 school-panel">
            <lib-user-record-table
              title="Contacts"
              [showViewMore]="false"
              [scrollable]="scrollable"
              [columnDefinitions]="contactsColumnDefinitions"
              [recordType]="UserRecordType.Contacts"
              [userTypeId]="userTypeId"
              (messageSent)="getMessagesData()">
            </lib-user-record-table>
          </div>
        }
      </ng-template>

      <!-- Students -->
      <ng-template #students>
        @if (studentsLoading) {
          <div class="grid-col-12 grid-md:col-12 background-white">
            <div class="loading-container">
              <p class="loading-text"> Loading students...</p>
            </div>
          </div>
        } @else if (studentsData()) {
          <div class="grid-col-12 student-panel">
            <lib-user-record-table
              title="Student(s)"
              emptyLabel="Students"
              [columnDefinitions]="studentsColumnDefinitions"
              [data]="studentsData()"
              [maxInitialRecords]="0"
              [recordType]="UserRecordType.Students"
              [showViewMore]="false"
              (studentClick)="onStudentClick($event)">
            </lib-user-record-table>
          </div>
        } @else {
          <div class="empty-panel grid-col-12 grid-md:col-12">
            <span class="user-record-error">No student data available.</span>
          </div>
        }
      </ng-template>

      <ng-template #tasks>
        <!-- User's Tasks with button functionality -->
        @if (taskData()) {
          <div class="grid-col-6 task-panel">
            <lib-user-record-table
              title="Tasks"
              label="View Tasks"
              [data]="taskData()"
              [columnDefinitions]="taskColumnDefinitions"
              [recordType]="UserRecordType.Tasks"
              [showButton]="true"
              [showStatusBadge]="true"
              buttonText="Assign Task"
              [showIcon]="true"
              iconName="add"
              (addNewButtonClick)="createTaskFunction()"
              (viewMoreClick)="viewMore('tasks')"
              (cbSort)="onSortChange(taskData())">
            </lib-user-record-table>
          </div>
        } @else {
          <div class="empty-panel grid-col-12 grid-md:col-12">
            <span class="user-record-error">No task data available.</span>
          </div>
        }
      </ng-template>

      <ng-template #messages>
        <!-- Messages -->
        @if (messagesData()) {
          <div class="grid-col-6 messages-panel">
            <lib-user-record-table
              title="Messages"
              label="View Messages"
              [data]="messagesData()"
              [columnDefinitions]="messagesColumnDefinitions"
              [recordType]="UserRecordType.Messages"
              [showButton]="true"
              buttonText="Send Message"
              (addNewButtonClick)="onMessageButtonClicked()"
              (viewMoreClick)="viewMessages()"
              (cbSort)="onSortChange(messagesData())">
            </lib-user-record-table>
          </div>
        } @else {
          <div class="empty-panel grid-col-12 grid-md:col-12">
            <span class="user-record-error">No message data available.</span>
          </div>
        }
      </ng-template>

      <ng-template #documents>
        <!-- Documents -->
        @if (documentData()) {
          <div class="grid-col-6 documents-panel">
            <lib-user-record-table
              title="Documents"
              label="View Documents"
              [data]="documentData()"
              [recordType]="UserRecordType.Documents"
              [columnDefinitions]="documentColumnDefinitions"
              (addNewButtonClick)="addDocumentsFunction()"
              (viewMoreClick)="viewMore('documents')"
              (cbSort)="onSortChange(documentData())">
            </lib-user-record-table>
          </div>
        } @else {
          <div class="empty-panel grid-col-12 grid-md:col-12">
            <span class="user-record-error">No document data available.</span>
          </div>
        }
      </ng-template>

      <ng-template #paymentInformation>
        <div class="grid-col-6 payment-panel">
          <lib-user-record-table
            title="Payment Information"
            [demo]="true"
            [recordType]="UserRecordType.PaymentInformation">
          </lib-user-record-table>
        </div>
      </ng-template>

      <ng-template #employees>
        @if (employeesData()) {
          <div class="grid-col-6 employee-panel">
            <lib-user-record-table
              title="Employees"
              label="View Employees"
              [data]="employeesData()"
              [recordType]="UserRecordType.Employees"
              [columnDefinitions]="employeesColumnDefinitions"
              (viewMoreClick)="viewMore('employees')"
              (cbSort)="onSortChange(employeesData())">
            </lib-user-record-table>
          </div>
        } @else {
          <div class="empty-panel grid-col-12 grid-md:col-12">
            <span class="user-record-error">No employee data available.</span>
          </div>
        }
      </ng-template>

      @if (userType !== adminUserTypes.Households) {
        <ng-container *ngTemplateOutlet="emails"></ng-container>
      }

      <ng-template #emails>
        <!-- Alternative approach using event output -->
        <div class="grid-col-6 email-panel">
          <lib-user-record-table
            title="Emails"
            label="View Emails"
            [data]="emailData()"
            [scrollable]="true"
            [recordType]="UserRecordType.Emails"
            [columnDefinitions]="emailColumnDefinitions"
            (viewMoreClick)="viewEmails()"
            (cbSort)="onSortChange(emailData())">
          </lib-user-record-table>
        </div>
      </ng-template>

      <ng-template #issueTracking>
        <!-- Issue Tracking -->
        <div class="grid-col-12 school-panel">
          <lib-user-record-table
            buttonText="New Issue"
            label="Track Issue"
            title="Issue Tracking"
            [columnDefinitions]="issueTrackingColumnDefinitions"
            [data]="issueTrackingData()"
            [expandable]="true"
            [scrollable]="true"
            [showViewMore]="false"
            [serverSidePaging]="true"
            [showButton]="true"
            [recordType]="UserRecordType.IssueTracking"
            [highlightActiveRows]="true"
            [subCellsKey]="'history'"
            (addNewButtonClick)="createNewIssue()"
            (editIssueClick)="editIssue($event)"
            (cbSort)="onIssueSortChange($event)">
          </lib-user-record-table>
        </div>
      </ng-template>

      <ng-template #incomeVerification>
        <!-- Income Verification -->
        <div class="grid-col-6">
          <lib-user-record-table
            title="Income Verification"
            [showButton]="false"
            [showViewMore]="false"
            [maxInitialRecords]="5"
            [columnDefinitions]="incomeVerificationColumnDefinitions"
            [data]="incomeVerificationData()"
            [recordType]="UserRecordType.IncomeVerification"
            [userTypeId]="userTypeId">
          </lib-user-record-table>
        </div>
      </ng-template>

      <ng-template #internalComments>
        <!-- Internal Comments -->
        @if (internalCommentsFilteredData()) {
          <div class="grid-col-6 comments-panel">
            <lib-user-record-table
              title="Internal Comments For SEAA use only"
              label="View Comments"
              emptyLabel="Internal Comments"
              [data]="internalCommentsFilteredData()"
              [showButton]="true"
              buttonText="Add Comment"
              [showIcon]="true"
              iconName="add"
              [recordType]="UserRecordType.Comments"
              (addNewCommentClick)="refreshInternalComments($event)"
              (viewMoreClick)="viewComments()">
            </lib-user-record-table>
          </div>
        } @else {
          <div class="empty-panel grid-col-12 grid-md:col-12">
            <span class="user-record-error">No internal comments data available.</span>
          </div>
        }
      </ng-template>
    </div>
  </div>
</div>
